import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { LocationService, ReasonService } from 'cbd-proxies';

FieldBuilder.setNamespace('Geographic');

export const STANDDEACTIVATION_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .checkbox('isActive', 'Entity.StandDeactivation.IsActive')
    .build(),
  FieldBuilder.foreignKey('standLocationId', 'Entity.Stand', LocationService)
    .queryFilter({ locationTypeEntityName: 'Stand' })
    .display('name')
    .displayFromNested('standLocationName')
    .sortBy('standLocationName')
    .keyField('id')
    .build(),
  FieldBuilder.foreignKey(
    'deactivationReasonId',
    'Entity.StandDeactivation.DeactivationReason',
    ReasonService,
  )
    .display('name')
    .displayFromNested('deactivationReasonName')
    .sortBy('deactivationReasonName')
    .keyField('id')
    .build(),
];

export const STANDDEACTIVATION_CONFIG = {
  entityName: 'StandDeactivation',
  localizationKey: 'Geographic::Entity.StandDeactivation',
  fields: STANDDEACTIVATION_FIELDS,
  permission: 'PlanningGeography.StandDeactivations',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.QueriesPlanning + MENU_NAME_SUFFIX,
};
